/*
<summary>
   This file defines the initial (empty) state for the User Created Inspection Record list
   (ToolManagement/GetUserInspectedList).
   Developer: Aashish Singh, Created Date: 27-Aug-2026
</summary>
*/

import { IUserInspectedListVM } from '../../models/response/IUserInspectedListResponse';

export const getUserInspectedListInitialState: IUserInspectedListVM = {
  ToolCheckInfoMasterLists: [],
  PagingDetails: {
    CurrentPage: 1,
    PageSize: 8,
    TotalPages: 0,
    TotalRecords: 0,
  },
};

export default getUserInspectedListInitialState;
